import { hotlineWhatsappNumber } from '~/constants/website'

export const createHotlineLink = (
  params?: Partial<Record<'text', string>> & Record<string, string>
) => {
  const urlParams = new URLSearchParams(params).toString()
  return `https://api.whatsapp.com/send?phone=${hotlineWhatsappNumber}&${urlParams}`
}
